import Footer from "@/components/layout/Footer";
import { ToastContainer } from "@/components/shared/Toast";
import { Box } from "@/components/ui/box";
import { VStack } from "@/components/ui/vstack";
import { FlatList, KeyboardAvoidingView, Platform } from "react-native";

interface ScreenProps {
  children: React.ReactNode;
  footer?: boolean;
  className?: string;
}

const Screen: React.FC<ScreenProps> = ({ children, footer = true, className }: Readonly<ScreenProps>) => {
  return (
    <Box className="bg-background-50 flex-1">
      <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === "ios" ? "padding" : "height"} keyboardVerticalOffset={80}>
        <FlatList
          style={{ flex: 1 }}
          contentContainerStyle={{ flexGrow: 1, justifyContent: "space-between" }}
          data={[]}
          renderItem={null}
          ListHeaderComponent={<VStack className={`gap-[32px] pb-[52px] pt-[44px] px-[20px] max-w-xl self-center w-full ${className}`}>{children}</VStack>}
          keyboardShouldPersistTaps="handled"
          ListFooterComponent={
            <>
              <ToastContainer />
              {footer && <Footer />}
            </>
          }
        />
      </KeyboardAvoidingView>
    </Box>
  );
};

export default Screen;
